const home = {
  // Hero
  hero_headline_1: 'The Leadership Your',
  hero_headline_family: 'Family',
  hero_headline_and: 'and',
  hero_headline_school: 'School',
  hero_headline_2: 'Need',
  hero_description: 'Transform your family relationships and educational management with methodologies proven by <strong>17 years of experience</strong>. Discover the path to leadership that generates real and lasting results.',
  hero_btn_books: 'Books',
  hero_btn_courses: 'Courses',
  hero_btn_mentorship: 'Mentoria SÍLEX',
  hero_stat_experience: 'Years of Experience',
  hero_stat_mba: 'USP/Esalq',

  // Books section
  books_title: 'Books and Works:',
  books_title_highlight: 'The Beginning of Transformation',
  books_subtitle: 'Books and e-books that have already transformed thousands of families and education professionals across Brazil',
  books_format: 'PDF E-book',
  books_btn_buy: 'Buy Now',
  books_btn_details: 'View Details',
  books_guarantee: '7-day Guarantee',
  books_coming_soon: 'Coming Soon',
  books_coming_new: 'New title coming soon',
  books_coming_desc: 'We are preparing more incredible content for you!',
  books_notify_label: 'Notify me when launched',
  books_details_hover: 'View Details',

  // Courses section
  courses_title: 'Elite Training:',
  courses_title_highlight: 'The Complete Method',
  courses_subtitle: 'Structured online courses with methodologies validated by over 17 years of practical experience',
  courses_badge: 'Online Course',
  courses_modules: 'modules',
  courses_btn_enroll: 'Enroll Now',
  courses_btn_details: 'View Details',
  courses_guarantee: '30-day Guarantee',
  courses_coming_new: 'New course coming soon',
  courses_coming_desc: 'We are preparing an incredible new training for you!',
  courses_students: 'students',
  courses_or: 'or',
  courses_hover_view: 'View Course',
  courses_testimonials_title: 'What Our Students Say',

  // SÍLEX Showcase (Vitrine SÍLEX na Home) — i18n: PT provisório (traduzir)
  silex_showcase_eyebrow: 'Método SÍLEX · 48 etapas',
  silex_showcase_title: 'Mentoria',
  silex_showcase_title_highlight: 'SÍLEX',
  silex_showcase_subtitle: 'Para pais e educadores que decidiram parar de disputar atenção — e começar a reconstruir presença, respeito e direção.',
  silex_showcase_body: 'Um método de cinco pilares para substituir o ruído dos confrontos pela clareza do diálogo, instalando uma aliança de respeito mútuo e engajamento prático entre pais, educadores e jovens.',
  silex_showcase_benefits_kicker: 'O que você recebe',
  silex_showcase_benefit_1_title: 'Método completo em 48 etapas',
  silex_showcase_benefit_1_desc: 'As 48 etapas do método, do diagnóstico à consolidação. Presente nos três planos, sem versão reduzida.',
  silex_showcase_benefit_2_title: 'Liberação por conclusão, não por calendário',
  silex_showcase_benefit_2_desc: 'Cada etapa abre quando a anterior é concluída. Você avança no seu ritmo, sem pular fundamento.',
  silex_showcase_benefit_3_title: 'Lives coletivas com o mentor',
  silex_showcase_benefit_3_desc: 'Três no Spark, seis no Lab, quinzenais no Protag. Encontros ao vivo para tirar dúvidas e ver o método aplicado a casos reais.',
  silex_showcase_benefit_4_title: 'Encontros individuais',
  silex_showcase_benefit_4_desc: 'Dois no Lab, de dois a quatro no Protag. Sessões reservadas ao seu cenário específico.',
  silex_showcase_benefit_5_title: 'Suporte no canal do seu plano',
  silex_showcase_benefit_5_desc: 'Pela plataforma no Spark, em grupo no Lab, direto no WhatsApp no Protag.',
  silex_showcase_benefit_6_title: 'Acesso por tempo definido',
  silex_showcase_benefit_6_desc: '90 dias no Spark, 180 no Lab, 365 no Protag. Compra única, sem assinatura e sem renovação automática.',
  silex_showcase_cta_secondary: 'Ver planos e detalhes',
  silex_showcase_plans_kicker: 'Conheça os três planos',
  silex_showcase_plan_spark_name: 'SÍLEX Spark',
  silex_showcase_plan_spark_price: 'R$ 997',
  silex_showcase_plan_spark_duration: '90 dias',
  silex_showcase_plan_spark_tagline: 'Começar com clareza',
  silex_showcase_plan_lab_name: 'SÍLEX Lab',
  silex_showcase_plan_lab_price: 'R$ 2.997',
  silex_showcase_plan_lab_duration: '180 dias',
  silex_showcase_plan_lab_tagline: 'Implementar com consistência',
  silex_showcase_plan_protag_name: 'SÍLEX Protag',
  silex_showcase_plan_protag_price: 'R$ 8.997',
  silex_showcase_plan_protag_duration: '365 dias',
  silex_showcase_plan_protag_tagline: 'O caminho principal',
  silex_showcase_plan_protag_highlight: 'Recomendado',
  silex_showcase_plan_duration_label: 'de acesso',
  silex_showcase_plan_card_cta: 'Ver detalhes',
  silex_showcase_plans_note: 'Opções de parcelamento disponíveis no checkout.',
  silex_showcase_guarantee_title: 'Garantia SÍLEX de Clareza e Aplicação',
  silex_showcase_guarantee_text: 'Sete dias para verificar se a estrutura faz sentido para o seu contexto. Se não fizer, o cancelamento é seu direito, sem burocracia.',
  silex_showcase_cta_primary: 'Conhecer a Mentoria SÍLEX',

  // Action Center
  action_title: 'Your Next Step:',
  action_title_highlight: 'Action Center',
  action_subtitle: 'Choose the ideal path for your transformation',
  action_quick_title: 'Quick Start',
  action_quick_desc: 'Start today with our e-books and transform your management',
  action_quick_btn: 'View Books',
  action_deep_title: 'Full Training',
  action_deep_desc: 'Master all strategies with our structured courses',
  action_deep_btn: 'View Courses',
  action_deep_badge: 'MOST POPULAR',
  action_elite_title: 'Elite Access',
  action_elite_desc: 'Exclusive mentorship for extraordinary results',
  action_faq_title: 'Frequently Asked Questions',
  action_faq_q1: 'How does course access work?',
  action_faq_a1: 'After purchase, you receive immediate and lifetime access to the complete content, allowing you to study at your own pace.',
  action_faq_q2: 'Are the e-books in physical or digital format?',
  action_faq_a2: 'All our books are in digital PDF format, allowing instant access after purchase.',
  action_faq_q3: 'What is the difference between courses and mentorship?',
  action_faq_a3: 'Courses are structured content for self-paced learning. Mentorship is personalized and exclusive one-on-one guidance.',
  action_faq_q4: 'Is there a satisfaction guarantee?',
  action_faq_a4: 'Yes! We offer a 7-day guarantee for e-books and 30 days for courses. If not satisfied, we refund your investment.',
  action_faq_q5: 'How does the mentorship application process work?',
  action_faq_a5: 'After filling out the form, our team reviews your profile and contacts you within 24 hours to schedule a conversation.',
  action_cta_title: 'Ready to Transform Your Leadership?',
  action_cta_desc: 'Join the professionals who have already transformed their lives with our methods',
  action_cta_btn_explore: 'Explore Products',

  // Social Proof
  social_title: 'Exclusive Content on Instagram',
  social_subtitle: 'Follow content on educational management and family relationships',
  social_follow: 'Follow Now',

  // Footer
  footer_partner_label: 'Projeto parceiro',
  footer_partner_name: 'Protocolo & Conexão',
  footer_partner_desc: 'Palestras e formações para escolas, famílias e empresas.',
  footer_partner_cta: 'Conhecer o projeto',
  footer_brand_desc: 'Transforming educational leaders and families through proven methodologies for over 17 years.',
  footer_products_title: 'Products',
  footer_products_books: 'Books & E-books',
  footer_products_courses: 'Online Courses',
  footer_products_talks: 'In-Company Talks',
  footer_products_webinars: 'Live Webinars',
  footer_company_title: 'Company',
  footer_company_about: 'About Us',
  footer_company_contact: 'Contact',
  footer_support_title: 'Support',
  footer_support_help: 'Help Center',
  footer_support_privacy: 'Privacy Policy',
  footer_support_terms: 'Terms of Use',
  footer_support_refund: 'Ask about refunds',
  footer_copyright: '© {{ano}} SB Family & Mastery. All rights reserved.',
  footer_secure: 'Secure Site',
  footer_payment: 'Protected Payment',

  // FAQ Page
  faq_badge: 'Help Center',
  faq_title: 'How can we help?',
  faq_subtitle: 'Find answers to the most common questions about the platform, courses, payments and certificates.',
  faq_cat_geral: 'General',
  faq_cat_acesso: 'Access & Account',
  faq_cat_cursos: 'Courses',
  faq_cat_pagamento: 'Payment',
  faq_cat_certificado: 'Certificates',
  faq_cat_mentoria: 'Mentorship',
  faq_not_found_title: 'Didn\'t find what you needed?',
  faq_not_found_desc: 'Our support team is available to help Monday to Friday, 8am to 6pm.',
  faq_not_found_btn: 'Talk to Support',

  // Cursos Page
  cursos_badge: 'Elite Programs',
  cursos_title: 'Course',
  cursos_title_highlight: 'Catalog',
  cursos_subtitle: 'Proven methodologies to transform your educational management and family relationships.',
  cursos_stat_courses: 'courses available',
  cursos_stat_rating: 'Average rating 4.8',
  cursos_stat_guarantee: '30-day Guarantee',
  cursos_search_placeholder: 'Search courses...',
  cursos_filter_all_areas: 'All Areas',
  cursos_filter_all_levels: 'All Levels',
  cursos_filter_all_durations: 'Any Duration',
  cursos_filter_clear: 'Clear',
  cursos_results_found_one: 'course found',
  cursos_results_found_many: 'courses found',
  cursos_results_none: 'No courses found',
  cursos_no_results_title: 'No results found',
  cursos_no_results_desc: 'Try adjusting filters or searching with different keywords.',
  cursos_no_results_btn: 'Clear Filters',
  cursos_badge_online: 'Online Course',
  cursos_modules_label: 'modules',
  cursos_enroll_btn: 'Enroll Now',
  cursos_details_btn: 'View Details',
  cursos_view_btn: 'View Course',
  cursos_cta_title: 'Want Faster Results?',
  cursos_cta_desc: 'Premium Mentorship is the most direct way to transform your school or family with personalized guidance.',
  cursos_students_label: 'students',
  cursos_or_label: 'or',

  // Sobre Page
  sobre_badge: 'About Us',
  sobre_title: '17 years shaping leaders who transform',
  sobre_subtitle: 'SB Family & Mastery was born from the conviction that genuine leadership begins at home and expands to institutions. We are an executive education platform with a clear mission: transform families and schools through applicable knowledge.',
  sobre_mission_label: 'Our Mission',
  sobre_vision_label: 'Our Vision',
  sobre_purpose_label: 'Our Purpose',
  sobre_mission_text: 'To empower educational and family leaders with practical tools and proven methodologies that generate real and measurable transformation in the lives of people and institutions.',
  sobre_vision_text: 'To be the leading reference in executive education for family and school management in Brazil, forming a generation of leaders who build lasting legacies.',
  sobre_purpose_text: 'We believe that every strengthened family and every well-managed school produces waves of positive impact that cross generations. That is why we do what we do.',
  sobre_values_title: 'Our Values',
  sobre_values_desc: 'The pillars that guide every decision, every piece of content and every interaction of our team.',
  sobre_team_badge: 'Who is behind it',
  sobre_team_title: 'Our Founding Team',
  sobre_team_desc: 'Professionals with solid combined experience in education, psychology and technology.',
  sobre_timeline_title: 'Our Journey',
  sobre_timeline_desc: '17 years of history, learning and impact.',
  sobre_cta_title: 'Be part of the transformation',
  sobre_cta_desc: 'Join the families and educators who have already chosen to grow with SB Family & Mastery.',
  sobre_cta_contact: 'Contact Us',

  // Contato Page
  contato_badge: 'Contact Us',
  contato_title: 'We are here to help you',
  contato_subtitle: 'Our support team responds within 24 business hours. Choose the most convenient channel for you.',
  contato_form_title: 'Send a message',
  contato_form_desc: 'Fill out the form below and we will get back to you within 24 business hours.',
  contato_name_label: 'Full name *',
  contato_email_label: 'Email *',
  contato_subject_label: 'Subject',
  contato_message_label: 'Message *',
  contato_send_btn: 'Send Message',
  contato_sending: 'Sending...',
  contato_success_title: 'Message sent!',
  contato_success_desc: 'Our team will get back to you within 24 business hours.',
  contato_success_new: 'Send new message',
  contato_error: 'Error sending. Please try again or use another channel.',
  contato_faq_title: 'Quick Questions',
  contato_faq_desc: 'Your question may already be answered in our FAQ:',
  contato_faq_all: 'View full Help Center',
  contato_hours_title: 'Business Hours',
  contato_online: 'Support online now',
  contato_hours_weekday: 'Monday – Friday',
  contato_hours_weekday_val: '8am to 6pm',
  contato_hours_saturday: 'Saturday',
  contato_hours_saturday_val: '9am to 1pm',
  contato_hours_sunday: 'Sunday & Holidays',
  contato_hours_sunday_val: 'Closed',
};

export default home;
